// Local navigation only. Scroll the existing workspace, accounting for its sticky tabs.
export function focusPreparation(element:HTMLElement|null){
 if(!element)return;
 const container=element.closest('[data-testid="job-primary-workspace"]') as HTMLElement|null;
 const tabs=container?.querySelector('[data-testid="job-section-tabs"]');
 const offset=(tabs?.getBoundingClientRect().height||0)+16;
 if(container){const top=container.scrollTop+element.getBoundingClientRect().top-container.getBoundingClientRect().top-offset;container.scrollTo({top:Math.max(0,top),behavior:'auto'});}
 else {element.style.scrollMarginTop='80px';element.scrollIntoView({block:'start',inline:'nearest',behavior:'auto'});}
 element.focus({preventScroll:true});
}
